import { render } from "./App.vue?vue&type=template&id=4ff1f8b7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ff1f8b7&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__